import { AuthUser } from '../types/auth';
import { HubSpotDeal } from '../types/hubspot';

interface AssignmentContext {
  hubspotOwnerIds?: string[];
}

function normalizeValue(value?: string | null): string {
  return String(value || '').trim().toLowerCase();
}

export function isAssignedToUser(
  deal: HubSpotDeal,
  user: AuthUser | null,
  context?: AssignmentContext
): boolean {
  if (!user) return false;

  const hubspotOwnerIds = Array.isArray(context?.hubspotOwnerIds)
    ? context?.hubspotOwnerIds
    : [];

  const userCandidates = new Set([
    normalizeValue(user.id),
    normalizeValue(user.email),
    normalizeValue(user.name),
    ...hubspotOwnerIds.map((ownerId) => normalizeValue(ownerId)),
  ].filter(Boolean));

  if (userCandidates.size === 0) return false;

  const dealCandidates = [
    deal.hubspot_owner_id,
    deal.deal_owner_id,
    deal.deal_owner_email,
    deal.deal_owner_name,
    deal.verantwortlicher_monteur_email,
    deal.verantwortlicher_monteur_name,
    deal.verantwortlicher_monteur,
  ]
    .map((value) => normalizeValue(value))
    .filter(Boolean);

  // Strict Scope "Meine Projekte": Ohne Assignment-Metadaten
  // wird der Deal nicht als "mein" interpretiert.
  if (dealCandidates.length === 0) {
    return false;
  }

  return dealCandidates.some((candidate) => userCandidates.has(candidate));
}
